import vendorTextReplacer from './vendor-text-replacer';

const urlCleaner = (url) => {
    return url ? vendorTextReplacer(url.toString()).replaceAll(' ', '') : '';
}

export default urlCleaner;